module.exports = __webpack_public_path__ + "img/404.cb5b4f56.png";